import React from 'react';
import { SectionHeader } from '../components/UI';
import { useInView } from '../hooks/useInView';
import { COURSE_DETAILS } from '../data/courseData';
import styles from './CourseDetails.module.css';

export default function CourseDetails() {
  const [ref, inView] = useInView();
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <SectionHeader
          label="Course at a Glance"
          title="Everything you need to know before enrolling"
          center
        />
        <div className={styles.grid} ref={ref}>
          {COURSE_DETAILS.map((d, i) => (
            <div
              key={i}
              className={`${styles.item} ${inView ? styles.visible : ''}`}
              style={{ transitionDelay: `${i * 0.06}s` }}
            >
              <div className={styles.icon}>{d.icon}</div>
              <div className={styles.label}>{d.label}</div>
              <div className={styles.value}>{d.value}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
